type SortItemsByReferenceOrderParams<
  TItemToSort,
  KItemKey extends keyof TItemToSort
> = {
  itemsToSort: Array<TItemToSort>;
  sortProperty: KItemKey;
  referenceSortOrder: Array<TItemToSort[KItemKey]>;
};

export function sortItemsByReferenceOrder<
  TItemToSort,
  KItemKey extends keyof TItemToSort
>({
  itemsToSort,
  sortProperty,
  referenceSortOrder,
}: SortItemsByReferenceOrderParams<TItemToSort, KItemKey>) {
  if (!itemsToSort) return null;
  if (!referenceSortOrder || referenceSortOrder.length === 0) {
    return itemsToSort;
  }

  const sortMap = itemsToSort.reduce(
    (accumulator, item) => accumulator.set(item[sortProperty], item),
    new Map<TItemToSort[KItemKey], TItemToSort>()
  );

  return referenceSortOrder
    .map((sortOrderId) => sortMap.get(sortOrderId))
    .filter(Boolean);
}
